import { post } from '../../api/commonAPI';
import { FETCH_LOGIN, LOGIN_SUCCESS, LOGIN_FAILS, REMOVE_AUTH_DETAILS} from './authActionTypes';
import {auth} from '../../api/apiPaths';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();

export const submitUserDetauls = (userDetails) => {
    return dispatch => {

        dispatch({ type: FETCH_LOGIN });

        post(auth, userDetails)
            .then(res => {
                const token = res?.data?.token;

                if (token) {
                    cookies.set('token', token, {
                        path: '/',
                        maxAge: 60 * 60 * 24 // 1 day
                    });
                }

                dispatch({
                    type: LOGIN_SUCCESS,
                    payload: res
                });
            })
            .catch(error => {
                dispatch({
                    type: LOGIN_FAILS,
                    payload: error
                });
            });
    };
};

export const removeAuth = () => {
    return dispatch => {
        dispatch({
            type: REMOVE_AUTH_DETAILS,
        });
    }
}
